import { PerformanceAudienceKpi } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { DashboardKpiCard } from '../DashboardKpiCard';
import { KPI_CONFIG } from './kpiConfig';

type PerformanceAudienceKpiRowProps = {
  kpis: PerformanceAudienceKpi[];
};

export const PerformanceAudienceKpiRow: FC<PerformanceAudienceKpiRowProps> = ({ kpis }) => {
  return (
    <div className='grid gap-4 sm:grid-cols-2 xl:grid-cols-4'>
      {kpis.map((kpi) => {
        const config = KPI_CONFIG[kpi.id];

        if (!config) {
          return null;
        }

        return (
          <DashboardKpiCard
            key={kpi.id}
            kpi={kpi}
            titleKey={config.titleKey}
            subtitleKey={config.subtitleKey}
            badgeKey={config.badgeKey}
          />
        );
      })}
    </div>
  );
};
